import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Form-level rule for experience and education: the end date can't be earlier than the start date.
// Checked on the group, so it updates when either date changes. An empty end date means "ongoing".
export const endDateNotBeforeStart: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
  const start = group.get('startDate')?.value;
  const end = group.get('endDate')?.value;
  if (!start || !end) {
    return null;
  }
  return new Date(end) < new Date(start) ? { endBeforeStart: true } : null;
};
